/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperReset = {
    /**
     * Reset all facets
     */
    resetFacets() {
        this.lastVisitedCategoryPath = this.currentCategoryPath
        this.facets = []
        this.selectedFacets = []
        this.filtersExpanded = false

        if (typeof this.persistFiltersExpandedState === 'function') {
            this.persistFiltersExpandedState(false)
        }
    },
    /**
     * Reset products
     */
    resetProducts() {
        this.products = []
        this.productsTotal = null
        this.pagesTotal = null
        this.pagesCurrent = 1
        this.pagesLoaded = []
        if (typeof this.resetActiveProductCache === 'function') {
            this.resetActiveProductCache()
        }
    }
}

export default liveSearchHelperReset
